const DigitalMarketingAgencySocialMarketing = () => {
  return (
    <>
      <div className="social-media-section section-space--sm bgc-background">
        <div className="section-space--sm-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-xl-8">
                <h3 className="heading-3 clr-text font-weight-semibold text-center mb-0">
                  We Have Extensive Experience in Social{" "}
                  <span className="clr-red">Media Marketing</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="list-group flex-row flex-wrap justify-content-center margin-bottom-13">
                <a
                  className="social-media-btn active"
                  data-bs-toggle="list"
                  href="#webDesign"
                >
                  <span className="d-grid place-content-center width-12 height-12 rounded-circle bgc-text-1 clr-paragraph flex-shrink-0 fs-20">
                    <i className="fas fa-cog"></i>
                  </span>
                  <span className="d-inline-block font-weight-bold fs-20 clr-paragraph">
                    Website Design
                  </span>
                </a>
                <a
                  className="social-media-btn"
                  data-bs-toggle="list"
                  href="#digitalMarketing"
                >
                  <span className="d-grid place-content-center width-12 height-12 rounded-circle bgc-text-1 clr-paragraph flex-shrink-0 fs-20">
                    <i className="far fa-bell"></i>
                  </span>
                  <span className="d-inline-block font-weight-bold fs-20 clr-paragraph">
                    Digital Marketing
                  </span>
                </a>
                <a
                  className="social-media-btn"
                  data-bs-toggle="list"
                  href="#emailMarketing"
                >
                  <span className="d-grid place-content-center width-12 height-12 rounded-circle bgc-text-1 clr-paragraph flex-shrink-0 fs-20">
                    <i className="far fa-envelope"></i>
                  </span>
                  <span className="d-inline-block font-weight-bold fs-20 clr-paragraph">
                    Email Marketing
                  </span>
                </a>
                <a
                  className="social-media-btn"
                  data-bs-toggle="list"
                  href="#seoMarketing"
                >
                  <span className="d-grid place-content-center width-12 height-12 rounded-circle bgc-text-1 clr-paragraph flex-shrink-0 fs-20">
                    <i className="far fa-chart-bar"></i>
                  </span>
                  <span className="d-inline-block font-weight-bold fs-20 clr-paragraph">
                    SEO Marketing
                  </span>
                </a>
              </div>
              <div className="tab-content">
                <div className="tab-pane fade show active" id="webDesign">
                  <div className="border border-red-clr rounded-4 padding-4">
                    <div className="social-media-content bgc-white rounded-4 section-space padding-x-2 padding-x-xsm-4 padding-x-sm-8 padding-x-md-12 padding-end-xxl-25">
                      <div className="row">
                        <div className="col-lg-7 col-xl-6 col-xxl-5 ms-lg-auto">
                          <h5 className="heading-5 font-weight-semibold margin-bottom-5 clr-text">
                            Custom-Tailored Email Campaigns
                          </h5>
                          <p className="clr-paragraph margin-bottom-8">
                            Level up your recovery with email campaigns proven
                            highly effective for leading eCommerce brands, and
                            backed by years of optimization and industry data.
                          </p>
                          <ul className="list gap-3">
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Done-for-you and proven effective
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Customized to your brand
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  A/B testing, customer segmenting, and more
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="digitalMarketing">
                  <div className="border border-red-clr rounded-4 padding-4">
                    <div className="social-media-content bgc-white rounded-4 section-space padding-x-2 padding-x-xsm-4 padding-x-sm-8 padding-x-md-12 padding-end-xxl-25">
                      <div className="row">
                        <div className="col-lg-7 col-xl-6 col-xxl-5 ms-lg-auto">
                          <h5 className="heading-5 font-weight-semibold margin-bottom-5 clr-text">
                            Custom-Tailored Email Campaigns
                          </h5>
                          <p className="clr-paragraph margin-bottom-8">
                            Level up your recovery with email campaigns proven
                            highly effective for leading eCommerce brands, and
                            backed by years of optimization and industry data.
                          </p>
                          <ul className="list gap-3">
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Done-for-you and proven effective
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Customized to your brand
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  A/B testing, customer segmenting, and more
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="emailMarketing">
                  <div className="border border-red-clr rounded-4 padding-4">
                    <div className="social-media-content bgc-white rounded-4 section-space padding-x-2 padding-x-xsm-4 padding-x-sm-8 padding-x-md-12 padding-end-xxl-25">
                      <div className="row">
                        <div className="col-lg-7 col-xl-6 col-xxl-5 ms-lg-auto">
                          <h5 className="heading-5 font-weight-semibold margin-bottom-5 clr-text">
                            Custom-Tailored Email Campaigns
                          </h5>
                          <p className="clr-paragraph margin-bottom-8">
                            Level up your recovery with email campaigns proven
                            highly effective for leading eCommerce brands, and
                            backed by years of optimization and industry data.
                          </p>
                          <ul className="list gap-3">
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Done-for-you and proven effective
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Customized to your brand
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  A/B testing, customer segmenting, and more
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="seoMarketing">
                  <div className="border border-red-clr rounded-4 padding-4">
                    <div className="social-media-content bgc-white rounded-4 section-space padding-x-2 padding-x-xsm-4 padding-x-sm-8 padding-x-md-12 padding-end-xxl-25">
                      <div className="row">
                        <div className="col-lg-7 col-xl-6 col-xxl-5 ms-lg-auto">
                          <h5 className="heading-5 font-weight-semibold margin-bottom-5 clr-text">
                            Custom-Tailored Email Campaigns
                          </h5>
                          <p className="clr-paragraph margin-bottom-8">
                            Level up your recovery with email campaigns proven
                            highly effective for leading eCommerce brands, and
                            backed by years of optimization and industry data.
                          </p>
                          <ul className="list gap-3">
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Done-for-you and proven effective
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Customized to your brand
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  A/B testing, customer segmenting, and more
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalMarketingAgencySocialMarketing;
